module.exports = __webpack_public_path__ + "static/media/Bell_beaker_eba_england_icon_200px.443b8f9c.png";